import React from 'react'
import Pt from 'prop-types'
import { HelpBlock } from 'react-bootstrap'

import Icon from '../../Icon'

export default function Suggestions({
  feedback = {},
  score,
}) {
  if (!feedback.warning && !feedback.suggestions && !score) {
    return false
  }

  const lowStrength = (
    <HelpBlock>
      <Icon name="unlock" /> Your password is extremely weak and very
      easy to guess. We recommend generating a strong random password
      using a password manager.
    </HelpBlock>
  )

  const strengthWords = [
    // Strength 0,
    lowStrength,
    // Strength 1,
    lowStrength,
    // Strength 2,
    lowStrength,
    // Strength 3
    <HelpBlock>
      <Icon name="unlock-alt" /> Your password is moderately easy to
      guess. We recommend generating a strong random password using a
      password manager.
    </HelpBlock>,
    // Strength 4
    <HelpBlock>
      <Icon name="lock" /> What a great password! That&apos;ll keep
      the hackers busy for ages!
    </HelpBlock>,
  ]

  const hasSuggestions = feedback.warning || (feedback.suggestions && feedback.suggestions.length > 0)

  return (
    <div>
      {score !== null && (
        strengthWords[score]
      )}

      {hasSuggestions && (
        <HelpBlock>
          You may be able to improve the strength of your password:
        </HelpBlock>
      )}

      {!!feedback.warning && (
        <HelpBlock>
          <strong>
            <Icon name="exclamation-triangle" /> {feedback.warning}
          </strong>
        </HelpBlock>
      )}

      {feedback.suggestions && feedback.suggestions.map(s => (
        <HelpBlock key={s}>
          <strong>
            <Icon name="info-circle" /> {s}
          </strong>
        </HelpBlock>
      ))}
    </div>
  )
}

Suggestions.propTypes = {
  feedback: Pt.shape({
    suggestions: Pt.arrayOf(Pt.string),
    warning: Pt.string,
  }),
  score: Pt.number,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/Password/Suggestions.jsx